<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
      <div class="row">
        <div class="col-12">
          <h3 class="display-4 text-white">Welcome {{ user.name }}</h3>
        </div>
        <div class="col-12 text-white">
          (<label v-for="(item, index) in user.groups" :key="item" v-show="!item.includes('wfiws-ems')">
            {{ item }}
            <span class="mr-1" v-if="user.groups.length - index - 1 > 0"
              >,</span
            ></label
          >)
        </div>
      </div>
    </base-header>
  </div>
</template>
<script>
// import MyTickets from "./Dashboard/MyTickets";

export default {
  data() {
    return {};
  },
  components: {
    // MyTickets
  },
  computed: {
    user() {
      return this.$store.getters.loginUser;
    },
  },
  methods: {},
  created() {},
};
</script>
<style scoped>
.divider {
  margin: 20px;
}
</style>
